export default __webpack_public_path__ + "static/media/GARZA.06cf4e77.png";